import {
  coohomHeaders,
  qunheHeaders,
  requestPerformancePrefix,
} from '../../constants';
import { IResponseHandlerData } from '../../types';
import {
  canIUseFeature,
  checkIfNeedCollect,
  formatUrl,
  getDocOrigin,
  getOrigin,
  getTraceId,
} from '../../utils/func';
import logger from '../../utils/logger';
import SystemOptions from '../../utils/options';
import { handleErrorResponse, handleSuccessResponse } from '../../utils/responseHandler';

const defaultXMLHttpRequestOpen =
  'XMLHttpRequest' in window ? XMLHttpRequest.prototype.open : undefined;

const defaultXMLHttpRequestSend =
  'XMLHttpRequest' in window ? XMLHttpRequest.prototype.send : undefined;

export default function () {
  const options = SystemOptions.getInstance().getOptions();

  if (canIUseFeature(!!XMLHttpRequest) && options.initPagePerformance && options.getAjaxPerformance) {
    const { performanceStartPrefix } = requestPerformancePrefix.ajax;

    (window as any).XMLHttpRequest.prototype.open = function (
      method: string,
      url: string,
      async: boolean,
      username?: string | null,
      password?: string | null,
    ) {
      this.url = url;
      this.method = method;
      this.api = formatUrl(url);
      this.async = async;
      this.traceId = getTraceId(options.trace128bit);
      this.pMark = checkIfNeedCollect(url, options);

      if (this.pMark) {
        if (options.debug) {
          logger.info('ajax opened[url: ' + this.api + ', TraceId: ' + this.traceId + ']');
        }

        window.performance.mark(`${performanceStartPrefix}${this.api}`);

        this.addEventListener('readystatechange', () => {
          // 在请求头中写入 TraceId
          if (this.readyState === 1 && getDocOrigin() === getOrigin(url)) {
            if (options.isCoohom) {
              this.setRequestHeader(coohomHeaders.TraceId, this.traceId);
              this.setRequestHeader(coohomHeaders.SpanId, this.traceId);
            } else {
              this.setRequestHeader(qunheHeaders.TraceId, this.traceId);
            }
          }
        }, false);
      }

      // @ts-ignore
      defaultXMLHttpRequestOpen!.apply(this, arguments);
    };

    (window as any).XMLHttpRequest.prototype.send = function(data: any) {
      this.addEventListener('readystatechange', () => {
        if (options.debug) {
          logger.info('ajax interceptor[url: ' + this.api + ', marked: ' + this.pMark + ']');
        }
        if (this.readyState === 4 && this.pMark) {
          const handleData = {
            url: this.url,
            data,
            apiType: 'ajax',
            statusCode: this.status,
            method: this.method,
            traceId: this.traceId,
            async: this.async,
          } as IResponseHandlerData;

          if ((this.status >= 200 && this.status < 300) || this.status === 304) {
            handleSuccessResponse(handleData);
          } else {
            handleErrorResponse(handleData);
          }
        }
      });

      defaultXMLHttpRequestSend!.call(this, data);
    };
  }
}
